import { CustomReportSectionsType } from './typesSection'
import { CustomReportCategoryType } from './typesCategory'
import { SetCompanyAction } from '../company/types'
import { ResponsiveLayouts } from '../../../pages/reporting/custom/components/grid.utils'
import { Company } from '../../../types/company/Company'
import { Dimension } from '../../../features/dimension/types/Dimension'
import { TranslationFields } from '../../../components/Form/TranslateFields'

export const SET_DATE = 'SET_DATE'
export const SET_ARGUMENTS = 'SET_ARGUMENTS'
export const REMOVE_ARGUMENT = 'REMOVE_ARGUMENT'
export const SET_ACTIVE_REPORT_ID = 'SET_ACTIVE_REPORT_ID'

export interface CustomReportArgument {
  id: number
  name: string
  type: CustomReportCategoryType
  values: Partial<Company | Dimension>[]
  reportId: number
  order?: number
}

export interface CustomReport extends Partial<TranslationFields> {
  id: number
  args?: CustomReportArgument[]
  sections: CustomReportSectionsType[]
  style: CustomReportStyle
  layouts?: ResponsiveLayouts
  name: string
  companyId?: string
  groupId?: number | null
  order: number
  type?: string
  group?: boolean
}

export interface PrintStyleSettings {
  paperSize: 'A4' | 'A3'
  orientation: 'portrait' | 'landscape'
  scale: 100 | 90 | 80 | 70 | 60 | 50
  margin: 'small' | 'medium' | 'large'
  outputFormat: 'pdf' | 'png' | 'jpg'
  pageNumbers: boolean
  pageBreaks: boolean
  forcedBreaks: number[]
  watermark: boolean
}

interface CustomReportStyle {
  orientation: 'landscape' | 'portrait'
  print?: PrintStyleSettings
}

export interface CustomReportGroup extends Partial<TranslationFields> {
  id: number
  groupId?: number | null
  name: string
  order: number
  group: boolean
}

export enum TimePeriodOptions {
  FiscalyearToDate = 'fiscalyeartodate',
  FiscalyearFirstMonth = 'fiscalyearfirstmonth',
  PreviousFiscalyear = 'previousfiscalyear',
  Currentfiscalyear = 'currentfiscalyear',
  CurrentMonth = 'currentmonth',
  CurrentYear = 'currentyear',
  PreviousFiscalyearToDate = 'previousfiscalyeartodate',
  YearToDate = 'yeartodate',
  PreviousYear = 'previousyear',
  Previousyeartodate = 'previousyeartodate',
  Past12months = 'past12months',
  Quarter = 'quarter',
  FromToDate = 'fromtodate',
  CustomPeriod = 'customperiod',
  CustomYear = 'customyear',
  CustomMonth = 'custommonth',
  CumulativeFiscalyear = 'cumulativefiscalyear',
  CurrentWeek = 'currentweek',
  CurrentDay = 'currentday'
}

export interface SetCustomReportDateAction {
  type: typeof SET_DATE
  payload: string
}

export interface SetCustomReportArgumentsAction {
  type: typeof SET_ARGUMENTS
  payload: CustomReportArgument[]
}

export interface RemoveCustomReportArgumentAction {
  type: typeof REMOVE_ARGUMENT
  payload: number
}

export interface SetActiveReportIdAction {
  type: typeof SET_ACTIVE_REPORT_ID
  payload: number | undefined
}

export type CustomReportsActionTypes =
  | RemoveCustomReportArgumentAction
  | SetCompanyAction
  | SetCustomReportArgumentsAction
  | SetCustomReportDateAction
  | SetActiveReportIdAction

export interface CustomReportStore {
  date?: string
  arguments?: CustomReportArgument[]
  activeReportId?: number
}
